import React from "react";
import {
  Table,
  TableHead,
  TableHeader,
  TableRow,
  TableBody,
  TableCell,
} from "@/components/ui/table";
import { TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

function Leaves({ data, onAddLeave, showAddButton = false, loading = false }) {
  return (
    <TabsContent className="mt-5" value="leaves">
      {showAddButton && (
        <div className="flex justify-end mb-4">
          <Button
            type="button"
            onClick={onAddLeave}
            className="bg-cyellow hover:bg-yellow-500 text-black font-semibold flex items-center gap-1.5 shadow-sm"
            size="sm"
          >
            <Plus size={16} />
            Add Leaves
          </Button>
        </div>
      )}
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Type</TableHead>
            <TableHead>From</TableHead>
            <TableHead>To</TableHead>
            <TableHead>Days</TableHead>
            <TableHead>Note</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {loading ? (
            [...Array(5)].map((_, i) => (
              <TableRow key={i}>
                <TableCell>
                  <Skeleton className="h-5 w-16 bg-neutral-800" />
                </TableCell>
                <TableCell>
                  <Skeleton className="h-5 w-24 bg-neutral-800" />
                </TableCell>
                <TableCell>
                  <Skeleton className="h-5 w-24 bg-neutral-800" />
                </TableCell>
                <TableCell>
                  <Skeleton className="h-5 w-12 bg-neutral-800" />
                </TableCell>
                <TableCell>
                  <Skeleton className="h-5 w-32 bg-neutral-800" />
                </TableCell>
                <TableCell>
                  <Skeleton className="h-5 w-16 bg-neutral-800" />
                </TableCell>
              </TableRow>
            ))
          ) : data && data.length > 0 ? (
            data.map((item, i) => (
              <TableRow key={i}>
                <TableCell>
                  <span className="capitalize px-2 py-0.5 rounded text-xs bg-neutral-800 border border-neutral-700 text-neutral-300">
                    {item?.leave_type || item?.type || "Casual"}
                  </span>
                </TableCell>
                <TableCell>
                  {item?.form_date || item?.from_date || "N/A"}
                </TableCell>
                <TableCell>{item?.to_date || "N/A"}</TableCell>
                  <TableCell>
                    {item?.days ||
                      (item?.form_date && item?.to_date
                        ? `${Math.max(
                            1,
                            Math.round(
                              (new Date(item.to_date) - new Date(item.form_date)) /
                                (1000 * 60 * 60 * 24)
                            ) + 1
                          )}`
                        : "N/A")}
                  </TableCell>
                  <TableCell>
                    {item?.notes || item?.note || item?.reason || "N/A"}
                  </TableCell>
                  <TableCell
                    className={`capitalize font-medium ${
                      item?.status === "approved"
                        ? "text-cgreen"
                        : item?.status === "rejected"
                        ? "text-cred"
                        : "text-cyellow"
                    }`}
                  >
                    {item?.status || "Pending"}
                  </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell
                colSpan={6}
                className="text-center py-6 text-neutral-400"
              >
                No leave records available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TabsContent>
  );
}

export default Leaves;
